import { AcceptanceDocumentsKeyType } from '../../keys';

const acceptanceDocumentsKeys: AcceptanceDocumentsKeyType = {
  accepting: 'Прийняття...',
  actionRequired: 'Потрібна дія',
  confirmConsent: 'Я підтверджую, що прочитав(-ла) та погоджуюся з',
  dearUser: 'Шановний користувачу,',
  notReadyToAccept: 'Не готові прийняти?',
  restrictedAccessNotice:
    'Доступ до вашого облікового запису обмежено, доки ви не приймете оновлені документи.',
  termsUpdateDescription:
    'У зв’язку з оновленням юридичної особи, що управляє платформою Archivizer, документи, що регулюють використання платформи, було оновлено. Щоб продовжити користуватися своїм обліковим записом, будь ласка, ознайомтеся та прийміть оновлені документи.',
  updatedDocuments: 'оновленими документами',
  updatedTerms: 'Оновлені умови'
};

export default acceptanceDocumentsKeys;
